import React from 'react';
import { Box, Typography, Button, Paper, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { t } from '../../../utils/textUtils';
import { formatDate } from '../utils/formatters';

const Notifications = ({ notifications }) => {
  return (
    <Paper
      variant="outlined"
      sx={{ 
        p: 3, 
        borderRadius: 2, 
        height: '100%',
        minHeight: '350px',
        borderColor: 'divider',
        bgcolor: '#ffffff'
      }}
    >
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        mb: 2,
        borderBottom: '1px solid',
        borderColor: 'divider',
        pb: 1
      }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: '#0f172a' }}>
          {t('PENGINGATAN')}
        </Typography>
        <Button 
          size="small" 
          sx={{ 
            color: '#0f172a',
            '&:hover': { bgcolor: '#F8FAFC' }
          }}
        >
          {t('TANDAI SEMUA SUDAH DIBACA')}
        </Button>
      </Box>
      
      {notifications.length > 0 ? (
        <List sx={{ py: 0 }}>
          {notifications.slice(0, 4).map((notif, idx) => (
            <ListItem 
              key={idx} 
              sx={{ 
                px: 1, 
                py: 1,
                borderBottom: idx < notifications.length - 1 ? '1px solid' : 'none',
                borderColor: 'divider',
                '&:hover': { bgcolor: '#F8FAFC' }
              }}
            >
              <ListItemIcon sx={{ minWidth: 40 }}>
                {notif.type === 'warning' ? (
                  <WarningAmberIcon sx={{ color: '#FF9800' }} />
                ) : notif.type === 'error' ? (
                  <ErrorIcon sx={{ color: '#F44336' }} />
                ) : (
                  <CheckCircleIcon sx={{ color: '#4CAF50' }} />
                )}
              </ListItemIcon>
              <ListItemText 
                primary={notif.message} 
                secondary={formatDate(notif.date)}
                primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }}
                secondaryTypographyProps={{ variant: 'caption' }}
              />
            </ListItem>
          ))}
        </List>
      ) : (
        <Box sx={{ py: 2, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            {t('TIDAK ADA PENGINGATAN DITEMUKAN')}
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default Notifications;
